import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Body2, Caption1, Dialog, InfoBox, StepActionButton, useWizardContext } from "@activecollab/components";
import PropTypes from "prop-types";
import TextareaProgress from "~/components/Inputs/TextareaProgress";

export const SuggestSubtasksStep = ({
  name,
  description,
  taskListName,
  projectName,
  projectDescription,
  onNextButtonClick,
}) => {
  const { t } = useTranslation();
  const [moreDetails, setMoreDetails] = useState("");
  const { goNext } = useWizardContext();

  const handlMoreDetailsChange = useCallback((e) => {
    setMoreDetails(e.target.value);
  }, []);

  const handleNextButtonClick = useCallback(() => {
    onNextButtonClick({
      context_message: moreDetails,
    });
    goNext();
  }, [onNextButtonClick, moreDetails, goNext]);

  return (
    <>
      <Dialog.Content>
        <InfoBox>
          {t(
            "ActiveCollab will recommend subtasks for your task, based on your input, task name, task description, task list name, project, and project description."
          )}
        </InfoBox>
        <div className="tw-my-6 tw-h-full">
          <div className="tw-flex tw-gap-0.5 tw-items-center tw-mb-2">
            <Caption1
              weight="bold"
              whitespace="nowrap"
              className=" tw-w-[132px]"
            >
              {t("Project")}:
            </Caption1>
            <span className="tw-truncate tw-flex-1">{projectName}</span>
          </div>
          {projectDescription ? (
            <div className="tw-flex tw-gap-0.5 tw-items-center tw-mb-2">
              <Caption1
                weight="bold"
                whitespace="nowrap"
                className=" tw-w-[132px]"
              >
                {t("Description")}:
              </Caption1>
              <Body2 className="tw-truncate tw-flex-1">{projectDescription}</Body2>
            </div>
          ) : null}
          <div className="tw-flex tw-gap-0.5 tw-items-center tw-mb-2">
            <Caption1
              weight="bold"
              whitespace="nowrap"
              className=" tw-w-[132px]"
            >
              {t("Task List")}:
            </Caption1>
            <Body2 className="tw-truncate tw-flex-1">{taskListName}</Body2>
          </div>
          <div className="tw-flex tw-gap-0.5 tw-items-center tw-mb-2">
            <Caption1
              weight="bold"
              whitespace="nowrap"
              className=" tw-w-[132px]"
            >
              {t("Task")}:
            </Caption1>
            <Body2 className="tw-truncate tw-flex-1">{name}</Body2>
          </div>
          {description ? (
            <div className="tw-flex tw-gap-0.5 tw-items-center tw-mb-2">
              <Caption1
                weight="bold"
                whitespace="nowrap"
                className=" tw-w-[132px]"
              >
                {t("Task Description")}:
              </Caption1>
              <Body2 className="tw-truncate tw-flex-1">{description}</Body2>
            </div>
          ) : null}
        </div>

        <div>
          <Caption1
            weight="bold"
            className="tw-mb-1"
          >
            {t("More Details")}
          </Caption1>
          <TextareaProgress
            className="tw-w-full"
            textareaClassName="tw-w-full expense_summary_textarea"
            value={moreDetails}
            onChange={handlMoreDetailsChange}
            maxNumChars={1000}
          />
          <Caption1 color="tertiary">
            {t("Share more details about your task goals to get better, more tailored suggestions.")}
          </Caption1>
        </div>
      </Dialog.Content>
      <>
        <Dialog.ContentDivider />
        <Dialog.Actions>
          <StepActionButton
            onNextButtonClick={handleNextButtonClick}
            actionLabel={t("Suggest Subtasks")}
          />
        </Dialog.Actions>
      </>
    </>
  );
};

SuggestSubtasksStep.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  taskListName: PropTypes.string,
  projectName: PropTypes.string,
  projectDescription: PropTypes.string,
  onNextButtonClick: PropTypes.func.isRequired,
};
